<template>
    <div class="border-work d-flex flex-wrap justify-content-center">
      <div class="left">
        <img src="/static/img/acCleaning/svg/decision-making.svg" class="img">
        <div>
          <h4 data-aos="fade-left">{{ $t('ac_cleaning.help_center_section.title') }}</h4>
          <p data-aos="fade-right" class="sub-text">{{ $t('ac_cleaning.help_center_section.subtitle') }}</p>
        </div>
      </div>
      <div class="right">
        <div class="button">
          <a
            class="d-flex justify-content-center align-items-center"
            href="javascript:void(0)"
            @click="handlePhoneClick"
          >
            <img src="/static/img/acCleaning/svg/call.svg" class="img-call" />
          </a>

          <!-- Modal shown only on mobile -->
          <div v-if="showPhoneOptions" class="mobile-phone-modal">
            <div class="d-flex flex-column align-items-center">
              <p>กรุณาเลือกเบอร์โทร:</p>
              <a @click="showPhoneOptions = false" href="tel:+6621131138">02-113-1138</a>
              <a @click="showPhoneOptions = false" href="tel:+66927572999">092-757-2999</a>
              <button class="px-2 rounded-md border-0" style="width: 80%;" @click="showPhoneOptions = false">ปิด</button>
            </div>
          </div>

        </div>
        <div class="button">
          <a class="d-flex justify-content-center align-items-center" :href="socialContacts.lineUrl" target="_blank">
            <img src="/static/img/acCleaning/svg/line.svg" class="img-line">
          </a>
        </div>
        <div class="button">
          <a class="d-flex justify-content-center align-items-center" :href="socialContacts.fbMessageUrl" target="_blank">
            <img src="/static/img/acCleaning/svg/messenger.svg" class="img-messenger">
          </a>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      socialContacts: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        title: 'BeNeat Help Center',
        subtitle: 'ให้ BeNeat ช่วยตอบทุกคำถามที่คุณลูกค้าสงสัย',
        showPhoneOptions: false
      }
    },
    methods: {
      handlePhoneClick () {
        const isMobile = window.innerWidth <= 768
        if (isMobile) {
          this.showPhoneOptions = true
        } else {
          window.location.href = 'tel:+6621131138'
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import '../../../static/sass/page/ac_cleaning.scss';
  
  .border-work {
    margin-top: 5%;
    border-radius: 24px;
    background-color: #F5F5F5;
    padding: 20px 40px;
    // place-items: center;
    width: 100%;
  }
  
  .title {
    font-size: 24px;
    font-weight: 500;
    color: black;
  }
  
  .subtitle {
    font-size: 18px;
    font-weight: 400;
    color: #747474;
    padding-top: 8px;
  }
  
  p {
    margin: 0;
  }
  
  .left {
    display: block;
    place-items: center;
    text-align: center;
  }
  
  .right {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 14px;
    margin-top: 10px;
  }
  
  .button {
    display: flex;
    height: 54px;
    width: 54px;
    border-radius: 4px;
    background-color: #00BCD414;
    place-content: center;
    cursor: pointer;
    transition-duration: 700ms;
  }
  
  .button:hover {
    background-color: #00bbd43a;
    transition-duration: 700ms;
  }
  
  .img-call {
    width: 30px;
  }
  
  .img-line {
    width: 32px;
  }
  
  .img-messenger {
    width: 32px;
  }
  
  .img {
    height: 64px;
    width: 64px;
  }

  .mobile-phone-modal {
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
    background: white;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    text-align: center;
    z-index: 9999;
  }

  
  @media (min-width: 1024px) {
    .border-work {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  
    .title {
      font-size: 32px;
      font-weight: 500;
      color: black;
    }
  
    .left {
      display: flex;
      align-items: center;
      gap: 32px;
      text-align: left;
    }
  
    .right {
      margin-top: 0;
    }
  
    .img {
      height: 96px;
      width: 96px;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/acCleaningRe/HelpCenter.vue